"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KpnBanner = void 0;
var React = _interopRequireWildcard(require("react"));
var _OldCallbackBanner = require("../../shared/containers/OldCallbackBanner");
var _NewLinkBanner = require("../../shared/containers/NewLinkBanner");
var _NewCallbackBanner = require("../../shared/containers/NewCallbackBanner");
var _OldLinkBanner = require("../../shared/containers/OldLinkBanner");
var _FlatSaleCallbackBannerContainer = require("../../shared/containers/FlatSaleCallbackBannerContainer");
var _FlatSaleLinkBanner = require("../../shared/containers/FlatSaleLinkBannerContainer/FlatSaleLinkBanner");
var _SuburbanCallbackBanner = require("../../shared/containers/SuburbanCallbackBannerContainer/SuburbanCallbackBanner");
var _SuburbanLinkBannerContainer = require("../../shared/containers/SuburbanLinkBannerContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const KpnBanner = _ref => {
  let {
    bannerType,
    newobjectsListingUrl,
    personalAgreementLink,
    defaultPhoneNumber,
    regionId,
    placeType,
    gaLabel,
    userId
  } = _ref;
  switch (bannerType) {
    case 'old_link':
      return /*#__PURE__*/React.createElement(_OldLinkBanner.OldLinkBannerContainer, {
        userId: userId,
        url: newobjectsListingUrl,
        placeType: placeType
      });
    case 'new_link':
      return /*#__PURE__*/React.createElement(_NewLinkBanner.NewLinkBannerContainer, {
        userId: userId,
        url: newobjectsListingUrl,
        placeType: placeType
      });
    case 'old_callback':
      return /*#__PURE__*/React.createElement(_OldCallbackBanner.OldCallbackBannerContainer, {
        personalAgreementLink: personalAgreementLink,
        defaultPhoneNumber: defaultPhoneNumber || '',
        regionId: regionId,
        placeType: placeType,
        gaLabel: gaLabel,
        userId: userId
      });
    case 'new_callback':
      return /*#__PURE__*/React.createElement(_NewCallbackBanner.NewCallbackBannerContainer, {
        personalAgreementLink: personalAgreementLink,
        defaultPhoneNumber: defaultPhoneNumber || '',
        regionId: regionId,
        placeType: placeType,
        gaLabel: gaLabel,
        userId: userId
      });
    case 'flat_sale_callback':
      return /*#__PURE__*/React.createElement(_FlatSaleCallbackBannerContainer.FlatSaleCallbackBannerContainer, {
        personalAgreementLink: personalAgreementLink,
        defaultPhoneNumber: defaultPhoneNumber || '',
        regionId: regionId,
        placeType: placeType,
        gaLabel: gaLabel,
        userId: userId
      });
    case 'flat_sale_link':
      return /*#__PURE__*/React.createElement(_FlatSaleLinkBanner.FlatSaleLinkBannerContainer, {
        url: newobjectsListingUrl,
        placeType: placeType
      });
    case 'suburban_sale_callback':
      return /*#__PURE__*/React.createElement(_SuburbanCallbackBanner.SuburbanCallbackBannerContainer, {
        personalAgreementLink: personalAgreementLink,
        defaultPhoneNumber: defaultPhoneNumber || '',
        regionId: regionId,
        placeType: placeType,
        gaLabel: gaLabel,
        userId: userId
      });
    case 'suburban_sale_link':
      return /*#__PURE__*/React.createElement(_SuburbanLinkBannerContainer.SuburbanLinkBannerContainer, {
        url: newobjectsListingUrl,
        placeType: placeType
      });
  }
};
exports.KpnBanner = KpnBanner;